import Box from "@mui/material/Box";
import { ITabPanelProps } from "../../../@types/components/tabPanelProps.types";

const TabPanel = ({ children, index, value }: ITabPanelProps) => {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
};

export default TabPanel;
